import { useMemo, useCallback } from "react";
import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";
import { useSelector } from "react-redux";
import {
    appointmentSteps,
    updateCurrentStep,
    resetAppointment,
    updateTestDetails,
    updateCentreDetails,
    updateSelectedDateTime,
    updateDiscountAmount,
} from "@/src/lib/store/pet-ct-appointment-new/slice";
import { useDispatch } from "react-redux";
import { formatTimeWithAmPm, formatDate } from "@/src/components/common/common";
import Skeleton from "@/src/components/common/Skeleton";
import { useRouter } from "next/router";
const Header = () => {
    const router = useRouter();
    const { query } = router;
    const appointmentNew = useSelector((state) => state.appointmentNew);
    const currentStep = appointmentNew.currentStep;
    const dispatch = useDispatch();
    const testDetails = useSelector(
        (state) => state.appointmentNew.testDetails
    );
    const centreName = useSelector(
        (state) => state.appointmentNew.centreDetails.centreName
    );
    const STEP_COPY = {
        [appointmentSteps.SELECT_APPOINTMENT]: {
            heading: "Select Appointment",
            sub: "",
        },
        [appointmentSteps.SELECT_CENTRE]: {
            heading: "Select Centre",
            sub: "Select Appointment",
        },
        [appointmentSteps.SELECT_DATE]: {
            heading: "Date & Time",
            sub: "Select Centre",
        },
        [appointmentSteps.SELECT_PATIENT]: {
            heading: "Your Information",
            sub: "Date & Time",
        },
        [appointmentSteps.PAYMENT_CONFIRMATION]: {
            heading: "Payment Confirmation",
            sub: "Your Information",
        },
    };
    const { heading = "", sub = "" } = STEP_COPY[currentStep] || {};

    const appointmentTitle = useMemo(() => {
        const scan = testDetails?.scanName || "";
        return `${scan} ${centreName ? `@ ${centreName}` : ""}`;
    }, [testDetails?.scanName, centreName]);

    const appointmentDateandTime = useMemo(() => {
        const dateVal = appointmentNew?.selectedDateTime?.date;
        const timeVal =
            appointmentNew?.selectedDateTime?.slotTime?.split(".")[0] || "";
        if (!dateVal || !timeVal) return "";
        return `${formatDate(dateVal, "DD MMMM YYYY")} at ${formatTimeWithAmPm(
            timeVal
        )}`;
    }, [
        appointmentNew?.selectedDateTime?.date,
        appointmentNew?.selectedDateTime?.slotTime,
    ]);
    const clearForStep = useCallback(
        (step) => {
            const actionsByStep = {
                [appointmentSteps.SELECT_APPOINTMENT]: () =>
                    dispatch(updateTestDetails({})),
                [appointmentSteps.SELECT_CENTRE]: () =>
                    dispatch(updateCentreDetails({})),
                [appointmentSteps.SELECT_DATE]: () =>
                    dispatch(updateSelectedDateTime({})),
                [appointmentSteps.SELECT_PATIENT]: () =>
                    dispatch(updateDiscountAmount({})),
            };
            actionsByStep[step]?.();
        },
        [dispatch]
    );
    const handleBackClick = useCallback(async () => {
        if (query?.itemId) {
            const { itemId, ...rest } = query;
            await router.replace(
                {
                    pathname: router.pathname,
                    query: rest,
                },
                undefined,
                { shallow: true }
            );
        }
        const prevStep = Math.max(
            currentStep - 1,
            appointmentSteps.SELECT_APPOINTMENT
        );
        if (prevStep !== currentStep) {
            clearForStep(prevStep);
            dispatch(updateCurrentStep(prevStep));
        }
    }, [currentStep, clearForStep, dispatch, query?.itemId, router]);

    const restPetCtAppointmentQuery = useCallback(async () => {
        if (query?.itemId) {
            const { itemId, ...rest } = query;
            await router.replace(
                {
                    pathname: router.pathname,
                    query: rest,
                },
                undefined,
                { shallow: true }
            );
        }
        dispatch(resetAppointment());
    }, [query?.itemId, router, dispatch]);

    return (
        <>
            <div className="flex flex-row justify-between items-center md:py-16 py-6">
                <div
                    className="flex flex-row items-center cursor-pointer hover:text-primary transition-all duration-300 group"
                    onClick={handleBackClick}
                >
                    {currentStep !== appointmentSteps.SELECT_APPOINTMENT && (
                        <Iconify
                            icon={IconCode.chevronDown}
                            width={28}
                            height={28}
                            className="rotate-90"
                        />
                    )}
                    <div className="text-xs md:uppercase capitalize md:tracking-wider tracking-normal group-hover:text-primary transition-all duration-300">
                        {sub}
                    </div>
                </div>

                <div className="md:text-xl text-sm md:font-bold font-medium capitalize">
                    {heading}
                </div>
                <div className="invisible md:invisible xs:hidden">{sub}</div>
            </div>

            {currentStep !== appointmentSteps.SELECT_APPOINTMENT && (
                <>
                    <p className="text-xs uppercase tracking-widest text-black md:font-medium font-normal md:mb-3 mb-1">
                        Appointment
                    </p>
                    <div className="flex flex-row items-center justify-between bg-white md:p-9 p-4 shadow-md ">
                        <div className="md:text-lg text-sm md:font-bold font-medium tracking-wide text-black">
                            {appointmentTitle}
                            <p className="text-sm text-gray-500 mt-0.5 font-medium">
                                {appointmentDateandTime}
                            </p>
                        </div>

                        <Iconify
                            onClick={restPetCtAppointmentQuery}
                            icon={IconCode.close}
                            width={28}
                            height={28}
                            className="rotate-90 cursor-pointer text-black"
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default Header;
